<template>
  <rv-radio :name="name" :label="label" option-a="Male" option-b="Female" v-model="data" v-on:input="update" :validation-rule="validationRule">
    <template slot="option-a">
      <b-icon
        pack="fas"
        icon="male">
      </b-icon>
      <span>Male</span>
    </template>
    <template slot="option-b">
      <b-icon
        pack="fas"
        icon="female">
      </b-icon>
      <span>Female</span>
    </template>
  </rv-radio>
</template>

<script>
import RvRadio from '../RvRadio'

export default {
  props: ['value'],
  components: { RvRadio },
  data() {
    return {
      label: 'What is your partner’s gender?',
      name: 'partner-gender',
      data: this.value,
      validationRule: {
        required: true
      }
    }
  },
  methods: {
    update: function() {
      this.$emit('input', this.data)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modules/inputs/basic-information/PartnerGender.vue